import classNames from "classnames";

import { BoldText } from "components/BoldText/BoldText";
import { BaseLayout } from "components/BaseLayout/BaseLayout";

import styles from "./styles.module.scss";
import { ClientGroupFooter } from "./ClientGroupFooter";
import { ClientGroupBody } from "./ClientGroupBody";

const Header = (): JSX.Element => (
  <BoldText className={styles.groupTitle}>Группа клиентов</BoldText>
);

export const ClientGroups = (): JSX.Element => (
  <BaseLayout
    className={classNames("ml-2 mt-3 mb-3", styles.container)}
    header={<Header />}
    footer={<ClientGroupFooter />}
  >
    <ClientGroupBody />
  </BaseLayout>
);
